import React from "react"
import { CallBadge } from "../CallChrome/CallBadge"

interface CustomCallTimerProps {
  duration: number
  maxDuration: number
}

export default function CustomCallTimer({
  duration,
  maxDuration,
}: CustomCallTimerProps) {
  const timeRemaining = Math.max(0, maxDuration - duration)
  const isLessThan1Minute = timeRemaining < 60

  const minutes = Math.floor(timeRemaining / 60)
    .toString()
    .padStart(2, "0")
  const seconds = (timeRemaining % 60).toString().padStart(2, "0")

  return (
    <CallBadge emphasis={isLessThan1Minute ? "danger" : "default"}>
      Remaining Time {minutes}:{seconds}
    </CallBadge>
  )
}
